module.exports = "<p>\r\n  sidebar works!\r\n</p>\r\n"